// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@west/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { orderStatusInformationStyles } from "@west/Overrides/Widgets/OrderStatus/OrderStatusInformation";
import { css } from "styled-components";

orderStatusInformationStyles.container = {
    gap: 0,
};

orderStatusInformationStyles.leftGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

orderStatusInformationStyles.rightGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

orderStatusInformationStyles.wrapper = {
    ...xOrderInformationStyles.headingAndTextStyles?.wrapper,
};

orderStatusInformationStyles.titleText = {
    ...xOrderInformationStyles.label,
};

orderStatusInformationStyles.statusText = {
    ...xOrderInformationStyles.value,
};

orderStatusInformationStyles.orderNumberText = {
    ...xOrderInformationStyles.value,
};

orderStatusInformationStyles.vatNumberText = {
    ...xOrderInformationStyles.value,
};

orderStatusInformationStyles.orderDateText = {
    ...xOrderInformationStyles.value,
};

orderStatusInformationStyles.poNumberText = {
    ...xOrderInformationStyles.value,
};

orderStatusInformationStyles.shippingMethodText = {
    ...xOrderInformationStyles.value,
};

orderStatusInformationStyles.termsText = {
    ...xOrderInformationStyles.value,
};
